






































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { identity, isEmpty, isNull } from "lodash";
import { storeSoap } from "@/store/modules/soap";
import { storeKonsul } from "@/store/modules/konsul";
import DataKonsul from "@/services/DataKonsul";
// import User from "@/utility/User";
// import { watch } from "fs";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import SoapRanapDokter from "@/services/SoapRanapDokter";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import SuratKonsul from "@/services/new/SuratKonsul";

@Component({
  components: {
    CardModalTtd
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardModalJawabKonsul extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() err!: object;
  @Prop() register!: string;
  @Prop() dataSoap: object;
  @Prop() jwbKonsul: any;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  validasi = [v => !!v || "*Kolom ini harus diisi"];

  listUnit = {};
  // diagnosis=this.statesoapdata
  anjuran = "";
  s = "";
  o = "";
  a = "";
  p = "";
  sess_login = this.stateuser;
  soap: object = {};
  raber: 0 | 1 = 0;

  created() {}

  get stateuser() {
    return userModule.user;
  }

  get statekonsul() {
    return storeKonsul.konsul;
  }

  get statejwbkonsul() {
    return storeKonsul.jwbkonsul;
  }

  get statesoapdetail() {
    if (this.stateuser.unit_id < "50") {
      return storeSoap.detailSoap;
    } else if (
      this.stateuser.unit_id >= "50" &&
      this.stateuser.unit_id < "80"
    ) {
      return SoapRanapStore.soap
        .filter(
          it =>
            it.user_id == this.stateuser.id &&
            it.unit_id == this.stateuser.unit_id
        )
        .map(it => {
          it["s"] = it.subjective;
          it["o"] = it.objective;
          it["a"] = it.assesment;
          it["p"] = it.plan;

          return it;
        });
    } else {
      return [];
    }
  }

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  get soapId() {
    return this.statesoapdetail[0]?.id ?? null;
  }

  get inputParams() {
    return {
      dr_konsulan_id: this.sess_login["id"],
      soap_id: this.soapId,
      note: this.anjuran,
      register_id: this.jwbKonsul["register"],
      pasien_cm: this.jwbKonsul["pasien"].rm,
      unit_id: this.sess_login["unit_id"],
      subjective: this.s,
      objective: this.o,
      assesment: this.a,
      plan: this.p,
      raber: this.raber,
      type: this.konsulType
    };
  }

  get konsulType() {
    return this.jwbKonsul?.suratKonsul?.type;
  }

  get title() {
    return this.konsulType === "konsul" ? "Konsul" : "Rujukan Internal";
  }

  @Watch("jwbKonsul")
  getJwbKonsul() {
    if (this.jwbKonsul["suratKonsul"].jawaban == null) {
      // if (this.jwbKonsul["suratKonsul"].type != "konsul") {
      if (this.statesoapdetail[0]?.id == undefined) {
        this.s = "";
        this.o = "";
        this.a = "";
        this.p = "";
      } else {
        this.s = this.statesoapdetail[0]["s"];
        this.o = this.statesoapdetail[0]["o"];
        this.a = this.statesoapdetail[0]["a"];
        this.p = this.statesoapdetail[0]["p"];
      }
      // } else {
      //   this.s = "";
      //   this.o = "";
      //   this.a = "";
      //   this.p = "";
      // }
      this.anjuran = "";
      this.raber = 0;
    } else {
      if (this.jwbKonsul["suratKonsul"].jawaban.soap_id) {
        this.s = this.jwbKonsul["suratKonsul"].jawaban.soap.s;
        this.o = this.jwbKonsul["suratKonsul"].jawaban.soap.o;
        this.a = this.jwbKonsul["suratKonsul"].jawaban.soap.a;
        this.p = this.jwbKonsul["suratKonsul"].jawaban.soap.p;
      } else {
        this.s = this.jwbKonsul["suratKonsul"].jawaban.subjective;
        this.o = this.jwbKonsul["suratKonsul"].jawaban.objective;
        this.a = this.jwbKonsul["suratKonsul"].jawaban.assesment;
        this.p = this.jwbKonsul["suratKonsul"].jawaban.plan;
      }

      this.anjuran = this.jwbKonsul["suratKonsul"].jawaban.note;
      this.raber = this.jwbKonsul["suratKonsul"].raber;
    }
  }

  tutup() {
    // storeKonsul.actKonsul_on_reg(this.register);
    this.dialog = false;
  }

  get saving() {
    return appModule.loading;
  }

  simpan() {
    if (this.readOnly) return;
    if (!this.saving) {
      appModule.setLoading(true);
      if (this.jwbKonsul["suratKonsul"].jawaban == null) {
        SuratKonsul.jawab(this.jwbKonsul["suratKonsul"].id, this.inputParams)
          .then(dt => {
            storeKonsul.actKonsul_on_reg(this.register);

            appModule.NoticeDelay(
              "Berhasil Menyimpan Jawaban Surat Rujukan Internal"
            );
            this.$emit("closePanel", this.jwbKonsul["suratKonsul"].id);
            this.dialog = false;

            if (this.stateuser.unit_id >= "50") {
              SoapRanapStore.getByRegister(this.register);
            } else {
              storeSoap.act_soap_on_reg(this.register);
            }
          })
          .finally(() => {
            appModule.setLoading(false);
          });
      } else {
        SuratKonsul.updateJawab(
          this.jwbKonsul["suratKonsul"].id,
          this.inputParams
        )
          .then(dt => {
            storeKonsul.actKonsul_on_reg(this.register);

            appModule.NoticeDelay(
              "Berhasil Ubah Jawaban Surat Rujukan Internal"
            );
            this.$emit("closePanel", this.jwbKonsul["suratKonsul"].id);
            this.dialog = false;

            if (this.stateuser.unit_id >= "50") {
              SoapRanapStore.getByRegister(this.register);
            } else {
              storeSoap.act_soap_on_reg(this.register);
            }
          })
          .finally(() => {
            appModule.setLoading(false);
          });
      }
    }
  }
}
